export const BREAKPOINTS = Object.freeze({
  TENANT_APP: Object.freeze({
    HEADER_NAV: '640px' as string,
  }),
  MOBILE: '768px' as string,
  TABLET: '1024px' as string,
  DESKTOP: '1200px' as string,
});

export const IMAGE_FILES = Object.freeze({
  LOGO: Object.freeze({
    ICON: 'zipteam-icon.svg',
    FULL: 'zipteam-logo.svg',
  }),
  PLACEHOLDER: Object.freeze({
    GENERAL: 'robot.png',
    NOT_FOUND: 'eye_glass.png',
    USER: 'user.svg',
  }),
  ACTION: {
    CREATE_TENANT: 'create-workspace.png',
  },
  TUTORIAL: {
    STEP1: 'feather.png',
    STEP2: 'contact.png',
    STEP3: 'star.png',
  },
});

export const INPUT_ACCEPTS = Object.freeze({
  CSV: '.csv',
  XLS: 'application/vnd.ms-excel',
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
});

export const INPUT_TYPES = Object.freeze({
  CSV: 'text/csv',
  XLS: 'application/vnd.ms-excel',
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
});

export const MAX_WIDTHS = Object.freeze({
  PRIMARY: '1248px' as string,
  SECONDARY: '912px' as string,
});

export const MIN_WIDTHS = Object.freeze({
  PRIMARY: '320px' as string,
  SECONDARY: '320px' as string,
});

export const MODAL_NAMES = Object.freeze({
  ADD_USER_LINK: 'add_user_link',
  ADD_USER_LANGUAGE_SKILL: 'add_user_language_skill',
  ASSESSMENT_DIALOG_DELETE_BY_IMPORT_HISTORY: 'assessment_dialog_delete_by_import_history',
  ASSESSMENT_UPLOAD_SKILL_SCORES: 'assessment_upload_skill_scores',
  CREATE_SKILL_TREE: 'create_skill_tree',
  CREATE_TENANT_PRIMARY: 'create_tenant_primary',
  CREATE_TENANT_USER_SKILL_PRIMARY: 'create_tenant_user_skill_primary',
  CREATE_PEER_REVIEW: 'create_peer_review',
  CONFIRM_CLOSE_USER_ACCOUNT: 'confirm_close_user_account',
  CONFIRM_DELETE_TENANT: 'confirm_delete_tenant',
  CONFIRM_LEAVE_TENANT: 'confirm_leave_tenant',
  EDIT_TENANT_USER_PRIMARY: 'edit_tenant_user_primary',
  EDIT_TENANT_USER_SKILL_PRIMARY: 'edit_tenant_user_skill_primary',
  IMPORT_ASSESSMENT: 'import_assessment',
  INVITE_TENANT_USER: 'invite_tenant_user',
  REVIEW_DELETE_REVIEW: 'review_delete_review',
  REVIEW_DIALOG_CLOSE: 'review_dialog_close',
  REVIEW_DIALOG_PUBLISH: 'review_dialog_publish',
  REVIEW_EDIT_EDITORS: 'review_edit_review_editors',
  REVIEW_EDIT_REVIEW_ATTRIBUTE: 'review_edit_review_attribute',
  REVIEW_EDIT_PARTICIPANTS: 'review_edit_participants',
  SKILL_TREE_DELETE_SKILL_TREE: 'skill_tree_delete_skill_tree',
  SKILL_TREE_DIALOG_PUBLISH: 'skill_tree_dialog_publish',
  SKILL_TREE_DIALOG_CLOSE: 'skill_tree_dialog_close',
  SKILL_TREE_EDIT_SKILL_TREE_ATTRIBUTE: 'skill_tree_edit_skill_tree_attribute',
  SKILL_TREE_EDIT_EDITORS: 'skill_tree_edit_skill_tree_editors',
  TEAM_ADD_TAG: 'team_add_tag',
  TEAM_CREATE_TEAM: 'team_create_team',
  TEAM_DELETE_TEAM: 'team_delete_team',
  TEAM_EDIT_ASSIGNEES: 'team_edit_assignees',
  TEAM_EDIT_TEAM: 'team_edit_team',
  TEAM_EDIT_TEAM_SHARE: 'team_edit_team_share',
  TEAM_EDIT_REQUIRED_SKILLS: 'team_edit_required_skills',
  TEAM_SELECT_SEARCH_VIEW: 'team_select_search_view',
  TEAM_VIEW_REVIEW_SUMMARY: 'team_view_review_summary',
  TENANT_APP_HELP_PRIMARY: 'tenant_app_help_primary',
  TENANT_APP_SETTINGS_SIDEBAR: 'tenant_app_settings_sidebar',
  UPDATE_USER_IMAGE: 'upload_user_image',
  USER_APP_HELP_PRIMARY: 'user_app_help_primary',
  USER_APP_SETTINGS_SIDEBAR: 'user_app_settings_sidebar',
});

export const THRESHOLDS = Object.freeze({
  WIDTH: Object.freeze({
    COLLAPSE: Object.freeze({
      PRIMARY: '978px',
    }),
  }),
});

export const TIMEOUTS = Object.freeze({
  SSO: Object.freeze({
    CALLBACK: 3000,
    REDIRECT: 3000,
  }),
  PENDING: {
    CLOSE_USER_ACCOUNT: 5000,
    DELETE_TENANT: 5000,
    LEAVE_TENANT: 5000,
  },
});

export const Z_INDEXES = Object.freeze({
  DEFAULT: 1 as number,
  DROPDOWN: 1000 as number,
  FOOTER: 9999 as number,
  HEADER: 500 as number,
  MODAL: 99999 as number,
  OVERLAY: 100000 as number,
  TOAST: 99999 as number,
  TOOLTIP: 2000 as number,
});

export const INPUT = Object.freeze({
  SKILL: Object.freeze({
    TAGS: Object.freeze({
      MAX_LENGTH: 5,
    }),
  }),
  EMAIL: Object.freeze({
    TAGS: Object.freeze({
      MAX_LENGTH: 100,
    }),
  }),
});
